import PageHeader from "../components/homepage/PageHeader";
import CallToAction from "../components/homepage/CallToAction";
import FaqSection from "../components/faqpage/faq";

function FAQ() {
  return (
    <>
      <PageHeader title={'FAQ'} />
      <FaqSection />
      <CallToAction />
    </>
  );
}

export default FAQ;
